import Utils from "../utils/Utils";

const employeeController = {
  getEmployeeCompanies: ({ email }) => {
    return Utils.controller(
      "api/employee/v1/getEmployeeCompanies",
      "",
      "GET",
      "Email=" + email,
      false,
      {},
      true
    );
  },

  forgetEmployeeUPI: ({ forgetUpiRequest }) => {
    return Utils.controller(
      "api/employee/v1/forgetEmployeeUpi",
      forgetUpiRequest,
      "POST",
      "",
      false,
      "",
      true
    );
  },
};

export default employeeController;
